import { buildPickReason, decisionPickRole } from "../../utils/decisionPickCopy";
import styles from "../../styles/components/home/YourDecisionCard.module.css";

function formatCatalogPrice(price) {
  const amount = Number(price);
  if (!Number.isFinite(amount)) return null;
  return `$${amount.toLocaleString()}`;
}

const YourDecisionCard = ({ choice, products = [], searchParams = null }) => {
  const product = choice?.product;
  const name = product?.name;
  if (!choice?.productId && !name) return null;

  const chosenId = choice.productId || product?._id || product?.id;
  const topProduct = products[0];
  const cheaperThanTop =
    topProduct &&
    String(topProduct._id || topProduct.id) !== String(chosenId) &&
    Number(product?.price) < Number(topProduct.price);
  const price = formatCatalogPrice(product?.price);
  const reason = choice.reason
    ? buildPickReason({
        product,
        advice: choice.reason,
        searchParams,
        otherNames: products
          .filter((item) => String(item._id || item.id) !== String(chosenId))
          .map((item) => item.name),
        role: decisionPickRole(chosenId, {
          topProduct,
          valueProduct: cheaperThanTop ? { _id: chosenId } : null,
        }),
      })
    : "";

  return (
    <a href="#home-match-results" className={styles.card}>
      <p className={styles.kicker}>Your decision</p>
      <p className={styles.name}>
        {name || "Your pick"}
        {price ? <span className={styles.price}> · {price}</span> : null}
      </p>
      {reason && <p className={styles.reason}>{reason}</p>}
    </a>
  );
};

export default YourDecisionCard;
